var logout = () => {
  localStorage.removeItem('MDM_MAIL');
  localStorage.removeItem('MDM_ACCESS_TOKEN');
  localStorage.removeItem('MDM_ACCESS_TOKEN_EXPIRES_AT');
  localStorage.removeItem('MDM_CART_TOKEN');
  localStorage.removeItem('MDM_ORDER_ID');
  localStorage.removeItem('MDM_CONNECT_AS');
  localStorage.removeItem('MDM_SELLER_ID');
  localStorage.removeItem('MDM_USER_AUTHENTIFICATION');
  sessionStorage.removeItem('MDM_CART_ADDRESSES');
  sessionStorage.removeItem('MDM_CART_PHONE');
  sessionStorage.removeItem('MDM_RESTORE_CART');
  sessionStorage.removeItem('MDM_CC_ELIGIBLE');
};

export default logout;